const faculty1 = 'Whenever you are concerned about a student, whether referrals are made or not, you should inform the appropriate contact within your unit as they may have additional information, insight, and access to resources that can support both you and the student. If you’re unsure of the appropriate contact, take the time to learn about the reporting structures and documenting procedures in your area. Some examples are chairs, program directors, registrars, or immediate supervisors.';
const faculty2 = ''


const student1 = 'Whenever you are assisting a student, whether referrals are made or not, you should inform the appropriate contact within your unit as they may have additional information, insight, and access to resources that can support both you and the student. If you’re unsure of the appropriate contact, take the time to learn about the reporting structures and documenting procedures in your area. Some examples are immediate supervisors, assistant deans, or program coordinators.';
const student2 = ''


const Resources = {
  faculty1,
  faculty2,
  student1,
  student2,
};

export default Resources;



// WEBPACK FOOTER //
// ./src/containers/Refer/ReferG/constants.jsx